//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpButton from '../button/Button.vue';
import DpCheckbox from '../checkbox/Checkbox.vue';
import DpCheckboxGroup from '../checkbox/CheckboxGroup.vue';
import DpDropdown from '../dropdown/Dropdown.vue';
import DpInput from '../input/Input.vue';
import DpControlGroup from './ControlGroup.vue';

export default {
  name: 'DpPageTitle',
  components: {
    DpButton,
    DpCheckbox,
    DpCheckboxGroup,
    DpDropdown,
    DpInput,
    DpControlGroup,
  },
  props: {
    title: { type: String, default: null },
    enableCreateButton: { type: Boolean, default: false },
    enableFilterSearch: { type: Boolean, default: false },
    enableFilterDropdown: { type: Boolean, default: false },
    createButtonText: { type: String, default: 'Create' },
    filterSearchPlaceholder: { type: String, default: 'Search...' },
    filterOptions: { type: Array, default: () => [] },
    filterOptionsModel: { type: Array, default: () => [] },
  },
  data() {
    return {
      filterText: null,
      showFilterDropdown: false,
      selectedFilters: [],
    };
  },
  watch: {
    filterOptionsModel: {
      deep: true,
      immediate: true,
      handler(selectedFilters) {
        this.selectedFilters = selectedFilters;
      },
    },
  },
  methods: {
    handleCreateClick() {
      this.$emit('create');
    },
    handleFilterChange() {
      this.$emit('change-filter-search', this.filterText);
    },
    handleFilterOptionsChange() {
      this.$emit('change-filter-options', this.selectedFilters);
    },
  },
};
